import { isBulkUploadDeliveryID } from 'constants/anytime-booking-constants';
import { filterHardBlockErrors } from 'helper/quote';
import _every from 'lodash/every';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import _some from 'lodash/some';

const stepReady = step => {
  if (!step) return false;
  if (!(step.poi && step.poi.id)) return false;
  return !!(step.name && step.phone);
};

const canCreateDelivery = (
  delivery,
  form,
  { isItemTypeMandatory = false, enableItemTypeFreeText = false },
) => {
  if (_get(delivery, 'fetchingQuote')) {
    return false;
  }

  const pickUpReady = stepReady(_get(delivery, 'detail.pickUp'));
  const dropOffSteps = _get(delivery, 'detail.dropOffs', []);
  const dropOffReady =
    dropOffSteps.length > 0 && _every(dropOffSteps, stepReady);
  if (!(pickUpReady && dropOffReady)) {
    return false;
  }

  const itemTypeValue = _get(delivery, 'detail.itemType');
  let isOtherItemType = false;
  if (itemTypeValue) {
    isOtherItemType = itemTypeValue.startsWith('7-');
  }
  const checkItemTypeFreeText = enableItemTypeFreeText && isOtherItemType;

  const isBulkUpload = isBulkUploadDeliveryID(delivery.id);

  if (isBulkUpload) {
    if (!_every(dropOffSteps.map(step => !!_get(step, 'itemWeight')))) {
      return false;
    }
  } else if (
    (isItemTypeMandatory && !_get(delivery, 'detail.itemType')) ||
    (checkItemTypeFreeText && !_get(delivery, 'detail.itemTypeFreeText')) ||
    !_get(delivery, 'detail.itemWeight') ||
    !_get(delivery, 'detail.parcelTotalSize')
  ) {
    return false;
  }

  if (
    !_every([
      _get(delivery, 'detail.paymentTypeID'),
      _get(delivery, 'detail.configuration.serviceType'),
      _get(delivery, 'detail.configuration.specialServiceType'),
    ])
  ) {
    return false;
  }

  const quoteSig = _get(delivery, 'quote.signature');
  if (!quoteSig) {
    return false;
  }

  // Check for hard-block quote errors (filter out soft-block)
  // Check both quote.errors and paxExpressError
  const quoteErrors = _get(delivery, 'quote.errors', []);
  const paxExpressError = _get(delivery, 'paxExpressError');

  // Combine errors from both sources
  const allErrors = [...quoteErrors];
  if (paxExpressError && paxExpressError.errorCode) {
    allErrors.push(paxExpressError);
  }

  const hardBlockErrors = filterHardBlockErrors(allErrors);
  if (!_isEmpty(hardBlockErrors)) {
    return false;
  }

  if (form && form.getFieldsError) {
    const fieldsError = form.getFieldsError();
    if (_some(Object.values(fieldsError), error => error && error.length > 0)) {
      return false;
    }
  }

  return true;
};

export default canCreateDelivery;
